export enum TipAcceptance {
  GET_PAYMENTS_REQUEST = '@tipacceptance/GET_PAYMENTS_REQUEST',
  GET_PAYMENTS_SUCCESS = '@tipacceptance/GET_PAYMENTS_SUCCESS',
  GET_PAYMENTS_FAIL = '@tipacceptance/GET_PAYMENTS_FAIL',

  GET_PAYMENT_SET_REQUEST = '@tipacceptance/GET_PAYMENT_SET_REQUEST',
  GET_PAYMENT_SET_SUCCESS = '@tipacceptance/GET_PAYMENT_SET_SUCCESS',
  GET_PAYMENT_SET_FAIL = '@tipacceptance/GET_PAYMENT_SET_FAIL',
}
